/*const barTemplate = `<iframe width="100%" height="20" scrolling="no" frameborder="no" allow="autoplay" 
src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/$tsrc$&color=%23555555&inverse=true&auto_play=false&show_user=true">
</iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a 
href="$psrc$" title="$title$" target="_blank" style="color: #cccccc; text-decoration: none;">Arrest All Mimics: The Creative Innovation Podcast</a> · <a href="$esrc$" 
title="$title$" target="_blank" style="color: #cccccc; text-decoration: none;">$title$</a></div>`*/

/*
<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" 
src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/862700581&color=%23000000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>
<div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
<a href="https://soundcloud.com/arrestallmimics" title="Arrest All Mimics: The Creative Innovation Podcast" target="_blank" style="color: #cccccc; text-decoration: none;">Arrest All Mimics: The Creative Innovation Podcast</a> · 
<a href="https://soundcloud.com/arrestallmimics/dawinderbansal" 
title="WHAT&#x27;S THE F&#x27;N POINT? Part 2: The Power of Creativity in a F&#x27;d Up World. Dawinder Bansal" target="_blank" style="color: #cccccc; text-decoration: none;">WHAT&#x27;S THE F&#x27;N POINT? Part 2: The Power of Creativity in a F&#x27;d Up World. Dawinder Bansal</a></div>
*/

//import Url from 'url-parse'

import apix from '@/api.js'

let cache = {}

export default {
  async getTrackData(url) {
    if(cache[url]) {
      return cache[url]
    }
    try {
      let murl = encodeURIComponent(url)
      let res = await apix.get(`collections/multi/soundcloud/${murl}/EN`)
      cache[url] = res.data
      console.log('res', res)
      return cache[url]
    }
    catch(err) {
      console.log(err.data)
      return 'Soundcloud not available'
    }
  },
  getBar20(res) {
    let track = encodeURIComponent(res.uri)
    let str = `<iframe width="100%" height="20" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=${track}&color=%23555555&inverse=true&auto_play=false&show_user=true"></iframe>`
    return str
  },
  getFullEmbed(res) {
    let track = encodeURI(res.uri)
    let str = `<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=${track}&color=%23000000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>`
    return str
  },
  async getEmbedCodeSmall(url) {
    url = this.getSoundcloudUrl(url)
    let res = await this.getTrackData(url)
    if(res === 'Soundcloud not available') {
      console.log('error', res.data.error)
      return ''
    }
    return this.getBar20(res)
  },
  async getEmbedCode(url) {
    url = this.getSoundcloudUrl(url)
    let res = await this.getTrackData(url)
    if(res === 'Soundcloud not available') {
      console.log('error', res.data.error)
      return ''
    }
    return this.getFullEmbed(res)
  },
  getSoundcloudUrl(podcastUrl) {
    if(!podcastUrl) {
      return ''
    }
    if(podcastUrl.indexOf(';') >= 0) {
      let scu = podcastUrl.split(';')
      return scu[0]
    }
    return podcastUrl
  },
  getAppleUrl(podcastUrl) {
    if(!podcastUrl) {
      return ''
    }
    if(podcastUrl.indexOf(';') >= 0) {
      return podcastUrl.split(';').pop()
    }
    return ''
  }
  

}